import { FC, FormEvent } from 'react';

import { useForm } from '@inertiajs/react';
import { clsx } from 'clsx';

import { Button } from '../../components/ui/Button';
import { CardContent, CardFooter } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Routes } from '../../models/routes';

type FormValues = {
    password: string;
    password_confirmation: string;
    reset_password_token: string;
};

type Props = {
    token: string;
};

export const ResetPasswordForm: FC<Props> = ({ token }) => {
    const { data, setData, put, processing, errors, setError, clearErrors } = useForm<FormValues>({
        password: '',
        password_confirmation: '',
        reset_password_token: token,
    });

    function submit(e: FormEvent) {
        e.preventDefault();
        clearErrors('password_confirmation');

        if (data.password !== data.password_confirmation) {
            setError('password_confirmation', 'Паролі не співпадають');
            return;
        }

        put(Routes.Password); // Devise uses same path (password path) but with PUT method
    }

    return (
        <form onSubmit={submit}>
            <CardContent className="grid gap-4">
                <input type="hidden" name="reset_password_token" value={token} />

                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        htmlFor="password"
                    >
                        Новий пароль
                    </label>
                    <Input
                        id="password"
                        type="password"
                        autoComplete="new-password"
                        className={clsx({
                            'border-red-600': errors.password,
                        })}
                        value={data.password}
                        onChange={(e) => setData('password', e.target.value)}
                    />
                    {errors.password && (
                        <p className="text-sm text-red-600">{errors.password}</p>
                    )}
                </div>

                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        htmlFor="password_confirmation"
                    >
                        Підтвердження паролю
                    </label>
                    <Input
                        id="password_confirmation"
                        type="password"
                        autoComplete="new-password"
                        className={clsx({
                            'border-red-600': errors.password_confirmation,
                        })}
                        value={data.password_confirmation}
                        onChange={(e) =>
                            setData('password_confirmation', e.target.value)
                        }
                    />
                    {errors.password_confirmation && (
                        <p className="text-sm text-red-600">
                            {errors.password_confirmation}
                        </p>
                    )}
                </div>
            </CardContent>
            <CardFooter className="flex flex-col pt-2">
                <Button
                    className="h-10 w-full text-sm font-semibold"
                    type="submit"
                    disabled={processing}
                >
                    Змінити пароль
                </Button>
            </CardFooter>
        </form>
    );
};
